var app = angular.module("leonardo");

var TriggerTaskDetailsDialog = function($scope, AttachmentService) {
  $scope.attachmentService = AttachmentService;
  $scope.task = $scope.ngDialogData.task;
  $scope.validData = ['Portfolio', 'Property', 'Unit', 'Workflow', 'Action Item', 'Dynamic Form', 'Completed By', 'Completed Date'];
  $scope.validDataField = ['Question', 'Answer'];
};

app.controller('TriggerTaskDetailsDialog', ['$scope', 'AttachmentService', TriggerTaskDetailsDialog]);
